import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.every";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.timers";
import { __assign, __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import { Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import { validateRuleData } from '@/decorators';
import { enumData } from '@/decorators';
import PaymentAccountDisclaimer from '@/views/finance/components/paymentAccountDisclaimer/idnex.vue';
import { namespace } from 'vuex-class';
import PayeeInfo from './payeeInfo.vue';
import MixinsCom from './mixins';
var Common = namespace('common');

var PayAccountAddOrEditPage = function (_super) {
  __extends(PayAccountAddOrEditPage, _super);

  function PayAccountAddOrEditPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.preBsbCode = "";
    _this.visible = false;
    _this.formData = PayAccountAddOrEditPage_1.initFormData();
    _this.formDataRule = {};
    _this.formDataAddRule = {};
    _this.formDataEditRule = {};
    _this.selectAccountCode = [];
    _this.accountCodeList = [];
    _this.currencyList = [];
    _this.registerCountryList = [];
    _this.openBankList = [];
    _this.showOpenBankList = [];
    _this.IsThirdPartEnum = [];
    _this.paymentAccountUnOfficialEnum = [];
    _this.paymentAccountFiduciaryEnum = [];
    _this.detailData = {};
    return _this;
  }

  PayAccountAddOrEditPage_1 = PayAccountAddOrEditPage;
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "signBodyName", {
    get: function get() {
      var _this = this;

      var item = this.accountCodeList.find(function (item) {
        return item.account_code === _this.formData.account_code;
      });

      if (item) {
        return item.sign_body_name;
      } else {
        return '';
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "bankFilterList", {
    get: function get() {
      var _this = this;

      if (this.formData.pay_bank_code && this.payId && (this.formData.isthird_party === null || this.formData.isthird_party === undefined)) {
        return [{
          bank_code: this.formData.pay_bank_code,
          bank_name: this.formData.pay_bank_name,
          bank_name_en: this.formData.pay_bank_name_en
        }];
      }

      var list = this.bankList.filter(function (item) {
        return item.is_third === String(_this.formData.isthird_party) && (item.status === _this.$enum.common.PSCBoolIntEnum.YES || _this.formData.pay_bank_code === item.bank_code);
      }) || [];
      return list;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowDisclaimer", {
    get: function get() {
      return this.formData.isthird_party === String(this.$enum.common.BoolIntEnum.YES);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowEntrust", {
    get: function get() {
      var _a = this.detailData,
          pay_account_status = _a.pay_account_status,
          is_unofficial = _a.is_unofficial;

      if (pay_account_status === this.$enum.finance.PayAccountStatusEnum.APPROVE) {
        return is_unofficial;
      }

      if (pay_account_status === this.$enum.finance.PayAccountStatusEnum.REJECT) {
        var account = this.$util.findItemByKeyValue(this.accountCodeList, this.formData.account_code, 'account_code');
        return this.isUnOfficePayByName(account);
      }

      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowPayeeInfo", {
    get: function get() {
      return this.isNeedPayeeInfo(this.formData);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowCaBankTip", {
    get: function get() {
      return this.isShowPayeeInfo && this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.CA;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowBsbCode", {
    get: function get() {
      if (!this.isShowPayeeInfo) {
        return false;
      }

      if (this.payId) {
        return true;
      }

      return this.formData.open_bank_country_code && this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.AU;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isBsbCodeDisabled", {
    get: function get() {
      return this.editDisabled && !this.$util.isEmpty(this.preBsbCode);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowSwiftCode", {
    get: function get() {
      var _this = this;

      var service_regist_country_list = [];

      if (this.payId) {
        service_regist_country_list = this.accountCodeList.filter(function (item) {
          return item.account_code === _this.formData.account_code;
        }).map(function (item) {
          return item.service_regist_country;
        });
      } else {
        service_regist_country_list = this.accountCodeList.filter(function (item) {
          return _this.formData.accountCodeIds.includes(item.account_code);
        }).map(function (item) {
          return item.service_regist_country;
        });
      }

      return !!(this.formData.open_bank_country_code && this.formData.isthird_party === String(this.$enum.common.BoolIntEnum.NO) && (this.formData.open_bank_country_code !== this.$enum.mine.RegisterAreaCodeEnum.CN || this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.CN && (service_regist_country_list.includes(this.$enum.mine.RegisterAreaCodeEnum.CN) && this.formData.currency_codes.some(function (item) {
        return item !== 'RMB';
      }) || service_regist_country_list.some(function (item) {
        return item !== _this.$enum.mine.RegisterAreaCodeEnum.CN;
      }))));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PayAccountAddOrEditPage.prototype, "isShowSwiftCodeTip", {
    get: function get() {
      var _this = this;

      var service_regist_country_list = [];

      if (this.payId) {
        service_regist_country_list = this.accountCodeList.filter(function (item) {
          return item.account_code === _this.formData.account_code;
        }).map(function (item) {
          return item.service_regist_country;
        });
      } else {
        service_regist_country_list = this.accountCodeList.filter(function (item) {
          return _this.formData.accountCodeIds.includes(item.account_code);
        }).map(function (item) {
          return item.service_regist_country;
        });
      }

      return this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.CN && (service_regist_country_list.includes(this.$enum.mine.RegisterAreaCodeEnum.CN) && this.formData.currency_codes.some(function (item) {
        return item !== 'RMB';
      }) || service_regist_country_list.some(function (item) {
        return item !== _this.$enum.mine.RegisterAreaCodeEnum.CN;
      }));
    },
    enumerable: false,
    configurable: true
  });

  PayAccountAddOrEditPage.initFormData = function () {
    return {
      pay_account_name: undefined,
      pay_bank_code: undefined,
      pay_bank_name: '',
      pay_bank_name_en: '',
      pay_account: undefined,
      accountCodeIds: [],
      account_Infos: [],
      id: undefined,
      isthird_party: undefined,
      currency_codes: [],
      open_bank_country_code: undefined,
      open_bank_country_name: undefined,
      payment_lines: '',
      open_bank_name: '',
      swift_code: '',
      bsb_code: '',
      accept: undefined,
      pay_bank_id: undefined,
      account_code: undefined,
      attachment_url: undefined,
      fiduciary: undefined,
      fiduciary_desc: undefined,
      payee_info: null
    };
  };

  PayAccountAddOrEditPage.prototype.onVisibleChange = function (data) {
    this.initFormData();

    if (data === false) {
      this.initFormData();
    } else {
      this.queryRegisterCountryList();
      this.queryCurrencyList();
      this.accountCodeList = this.$util.deepCopy(this.accountList);

      if (this.payId) {
        this.queryPayAccountDetail();
      }
    }
  };

  PayAccountAddOrEditPage.prototype.onPayBankCodeChange = function (bankCode) {
    if (bankCode) {
      this.queryOpenBankList(bankCode);
    }
  };

  PayAccountAddOrEditPage.prototype.onOpenBankNameChange = function (bankName) {
    this.addSelectedOpenBank(bankName);
  };

  PayAccountAddOrEditPage.prototype.onPayIdChange = function (data) {
    if (data) {
      this.formDataRule = this.formDataEditRule;
    } else {
      this.formDataRule = this.formDataAddRule;
    }
  };

  PayAccountAddOrEditPage.prototype.addSelectedOpenBank = function (bankName) {
    if (this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.CN && this.formData.isthird_party === String(this.$enum.common.BoolIntEnum.NO)) {
      if (bankName) {
        var exists = this.showOpenBankList.some(function (item) {
          return item.bank_branch_name === bankName;
        });

        if (exists) {
          return;
        }

        var selected = this.$util.findItemByKeyValue(this.openBankList, bankName, 'bank_branch_name');

        if (!selected) {
          return;
        }

        var merged = __spreadArrays([selected], this.showOpenBankList.filter(function (item) {
          return item.bank_branch_name !== bankName;
        }));

        this.showOpenBankList = merged.slice(0, PayAccountAddOrEditPage_1.OPEN_BANK_LIST_MAX_COUNT);
      }
    }
  };

  PayAccountAddOrEditPage.prototype.initFormData = function () {
    this.formData.accountCodeIds = [];
    this.formData = PayAccountAddOrEditPage_1.initFormData();
  };

  PayAccountAddOrEditPage.prototype.queryRegisterCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryRegisterCountryList()];

          case 1:
            res = _a.sent();
            this.registerCountryList = res.data;
            return [2];
        }
      });
    });
  };

  PayAccountAddOrEditPage.prototype.queryOpenBankList = function (bankCode) {
    return __awaiter(this, void 0, Promise, function () {
      var res;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.showOpenBankList = [];
            return [4, this.$api.finance.queryOpenBankList({
              bank_code: bankCode
            })];

          case 1:
            res = _a.sent();
            this.openBankList = res.data.filter(function (item) {
              return item.status === _this.$enum.common.PSCBoolIntEnum.YES || item.bank_branch_name === _this.formData.open_bank_name;
            });
            ;
            this.showOpenBankList = this.openBankList.slice(0, PayAccountAddOrEditPage_1.OPEN_BANK_LIST_MAX_COUNT);
            this.addSelectedOpenBank(this.formData.open_bank_name);
            return [2];
        }
      });
    });
  };

  PayAccountAddOrEditPage.prototype.queryCurrencyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryCurrencyList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.currencyList = data;
            return [2];
        }
      });
    });
  };

  PayAccountAddOrEditPage.prototype.getAddRuleData = function (data) {
    var _this = this;

    var rules = this.$util.mergeValidate(data, __assign({
      open_bank_country_code: [{
        required: true,
        message: this.t('开户行名称必填')
      }],
      open_bank_name: [{
        required: true,
        message: this.t('开户行名称必填')
      }],
      payment_lines: [{
        required: true,
        message: this.t('联行号必填')
      }],
      swift_code: [{
        required: true,
        message: this.t('swift_code必填')
      }],
      accountCodeIds: [{
        required: true,
        message: this.t('请选择可充值账户')
      }],
      'accountCodeIds.*': [{
        validator: function validator(rule, value, callback) {
          return __awaiter(_this, void 0, void 0, function () {
            var _this = this;

            return __generator(this, function (_a) {
              this.$nextTick(function () {
                var index = rule.field.split('.')[1];
                var account = _this.accountCodeList[index];

                var isChecked = _this.formData.accountCodeIds.includes(account.account_code);

                if (!isChecked) {
                  callback();
                }

                var isNeedUpload = _this.isUnOfficePayByName(account);

                if (!isNeedUpload) {
                  callback();
                }

                if (_this.$util.isEmpty(account.fiduciary)) {
                  callback(new Error(_this.t('请选择受托关系')));
                }

                if (account.fiduciary === _this.$enum.finance.PaymentAccountFiduciaryEnum.OTHER && _this.$util.isEmpty(account.fiduciary_desc)) {
                  callback(new Error(_this.t('请输入受托关系描述')));
                }

                if (_this.$util.isEmpty(account.attachment_url)) {
                  callback(new Error(_this.t('请上传委托付款函')));
                }

                callback();
              });
              return [2];
            });
          });
        }
      }],
      accept: [{
        validator: this.validateAgree()
      }]
    }, this.payeeInfoRule()));
    rules.bsb_code = [{
      validator: this.validateBsbCode()
    }];
    this.formDataAddRule = rules;
    this.formDataRule = this.formDataAddRule;
  };

  PayAccountAddOrEditPage.prototype.getEditRuleData = function (data) {
    var rules = this.$util.mergeValidate(data, __assign({
      open_bank_country_code: [{
        required: true,
        message: this.t('开户行名称必填')
      }],
      open_bank_name: [{
        required: true,
        message: this.t('开户行名称必填')
      }],
      payment_lines: [{
        required: true,
        message: this.t('联行号必填')
      }],
      swift_code: [{
        required: true,
        message: this.t('swift_code必填')
      }],
      attachment_url: [{
        required: true,
        message: this.t('请上传委托付款函')
      }],
      fiduciary: [{
        required: true,
        message: this.t('请选择受托关系')
      }],
      fiduciary_desc: [{
        required: true,
        message: this.t('请输入受托关系描述')
      }],
      accept: [{
        validator: this.validateAgree()
      }]
    }, this.payeeInfoRule()));
    rules.bsb_code = [{
      validator: this.validateBsbCode()
    }];
    this.formDataEditRule = rules;
  };

  PayAccountAddOrEditPage.prototype.validateBsbCode = function () {
    var _this = this;

    return function (rule, value, callback) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.AU && this.$util.isEmpty(value)) {
            callback(new Error(this.t('境内汇款代码必填')));
          } else {
            callback();
          }

          return [2];
        });
      });
    };
  };

  PayAccountAddOrEditPage.prototype.created = function () {};

  PayAccountAddOrEditPage.prototype.queryPayAccountDetail = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, account_code, sign_body_name, sign_business_list_text, fiduciary, open_bank_country_code, item, newItem;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.queryPayAccountDetail({
              id: this.payId
            })];

          case 1:
            data = _a.sent().data;
            this.detailData = data || {};
            this.formData = data;
            this.formData.id = this.payId;
            this.preBsbCode = !this.$util.isEmpty(data.bsb_code) ? data.bsb_code : "";
            account_code = data.account_code, sign_body_name = data.sign_body_name, sign_business_list_text = data.sign_business_list_text, fiduciary = data.fiduciary, open_bank_country_code = data.open_bank_country_code;

            if (this.$util.isEmpty(fiduciary)) {
              this.formData.fiduciary = undefined;
            }

            if (this.$util.isEmpty(open_bank_country_code)) {
              this.formData.open_bank_country_code = undefined;
            }

            this.resetPayeeInfo(this.formData.payee_info);

            if (this.isShowPayeeInfo) {
              setTimeout(function () {
                var _a;

                (_a = _this.$refs.payeeInfo) === null || _a === void 0 ? void 0 : _a.getRegionList();
              }, 0);
            }

            item = this.accountCodeList.find(function (item) {
              return item.account_code === account_code;
            });

            if (!item) {
              newItem = {
                account_code: account_code,
                sign_body_name: sign_body_name,
                sign_business_list_text: sign_business_list_text,
                disabled: true
              };
              this.accountCodeList.unshift(newItem);
            }

            return [2];
        }
      });
    });
  };

  PayAccountAddOrEditPage.prototype.handleIsthirdPartyChange = function () {
    this.formData.pay_bank_code = undefined;
    this.formData.pay_bank_name = '';
    this.formData.pay_bank_name_en = '';
    this.resetPayeeInfo();
  };

  PayAccountAddOrEditPage.prototype.handlepayBankCodeChange = function (bankCode) {
    var bankItem = this.bankList.find(function (item) {
      return item.bank_code === bankCode;
    });
    this.formData.pay_bank_name = (bankItem === null || bankItem === void 0 ? void 0 : bankItem.bank_name_cn) || '';
    this.formData.pay_bank_name_en = (bankItem === null || bankItem === void 0 ? void 0 : bankItem.bank_name_en) || '';

    if (bankCode) {
      if (this.formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.CN && this.formData.isthird_party === String(this.$enum.common.BoolIntEnum.NO)) {
        this.formData.open_bank_name = '';
        this.formData.payment_lines = '';
      }
    }
  };

  PayAccountAddOrEditPage.prototype.handleOpenBankListSearch = function (val) {
    this.showOpenBankList = this.openBankList.filter(function (item) {
      return String(item.bank_branch_name).toUpperCase().indexOf(val.toUpperCase()) > -1;
    }).sort(function (a, b) {
      return a.bank_branch_name.length - b.bank_branch_name.length;
    }).slice(0, PayAccountAddOrEditPage_1.OPEN_BANK_LIST_MAX_COUNT);
  };

  PayAccountAddOrEditPage.prototype.handleOpenBankCountryChange = function () {
    var _this = this;

    var items = this.registerCountryList.find(function (item) {
      return _this.formData.open_bank_country_code === item.country_code;
    });
    this.formData.open_bank_country_name = items === null || items === void 0 ? void 0 : items.country_name;
    this.resetPayeeInfo();
  };

  PayAccountAddOrEditPage.prototype.handleOpenBankNameChange = function (branchName) {
    var openBankItem = this.openBankList.find(function (item) {
      return item.bank_branch_name === branchName;
    });
    this.formData.payment_lines = openBankItem === null || openBankItem === void 0 ? void 0 : openBankItem.bank_branch_code;
  };

  PayAccountAddOrEditPage.prototype.onBeforeUpload_prove_file = function (file, index) {
    return __awaiter(this, void 0, Promise, function () {
      var formData, _a, data, code, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            formData = new FormData();
            formData.append('file', file);
            return [4, this.$api.finance.uploadPayAccountAttachment(formData)];

          case 1:
            _a = _b.sent(), data = _a.data, code = _a.code, message = _a.message;

            if (code === 0) {
              this.$message.success(this.t('上传成功'));

              if (index !== -1) {
                this.$set(this.accountCodeList[index], 'attachment_url', data.file_path);
                this.$set(this.accountCodeList[index], 'preview_url', data.preview_url);
                this.validFormField(["accountCodeIds." + index]);
              } else {
                this.formData.attachment_url = data.file_path;
                this.formData.preview_url = data.preview_url;
              }
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  PayAccountAddOrEditPage.prototype.onCheckError = function (type, file, ruleData) {
    switch (type) {
      case 'checkExt':
        this.$message.error(this.t('请选择PDF/ZIP/PNG/JPG格式文件上传'));
        break;

      case 'checkSize':
        var size = ruleData[0].max_size_in_byte / 1024 / 1024;
        this.$message.error(this.t("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7{0}M", [size]));
        break;
    }
  };

  PayAccountAddOrEditPage.prototype.handleSubmit = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.$refs.formDataRef.validate(function (valid) {
          return __awaiter(_this, void 0, Promise, function () {
            var formData, id, pay_account_name, pay_account, pay_bank_id, account_code, isthird_party, pay_bank_code, pay_bank_name, pay_bank_name_en, open_bank_country_code, open_bank_country_name, open_bank_name, payment_lines, swift_code, bsb_code, currency_codes, attachment_url, accept, fiduciary, fiduciary_desc, account_Infos, payee_info, commonParams, tips, modal_1, postData, res, data, errors_1, h_1;

            var _this = this;

            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!valid) {
                    return [2];
                  }

                  formData = this.$util.deepCopy(this.formData);
                  this.resetParams(formData);
                  id = formData.id, pay_account_name = formData.pay_account_name, pay_account = formData.pay_account, pay_bank_id = formData.pay_bank_id, account_code = formData.account_code, isthird_party = formData.isthird_party, pay_bank_code = formData.pay_bank_code, pay_bank_name = formData.pay_bank_name, pay_bank_name_en = formData.pay_bank_name_en, open_bank_country_code = formData.open_bank_country_code, open_bank_country_name = formData.open_bank_country_name, open_bank_name = formData.open_bank_name, payment_lines = formData.payment_lines, swift_code = formData.swift_code, bsb_code = formData.bsb_code, currency_codes = formData.currency_codes, attachment_url = formData.attachment_url, accept = formData.accept, fiduciary = formData.fiduciary, fiduciary_desc = formData.fiduciary_desc, account_Infos = formData.account_Infos, payee_info = formData.payee_info;
                  commonParams = {
                    pay_account_name: pay_account_name,
                    pay_account: pay_account,
                    isthird_party: isthird_party,
                    pay_bank_code: pay_bank_code,
                    pay_bank_name: pay_bank_name,
                    pay_bank_name_en: pay_bank_name_en,
                    open_bank_country_code: open_bank_country_code,
                    open_bank_country_name: open_bank_country_name,
                    open_bank_name: open_bank_name,
                    payment_lines: payment_lines,
                    swift_code: swift_code,
                    bsb_code: bsb_code,
                    currency_codes: currency_codes,
                    accept: accept,
                    payee_info: payee_info
                  };
                  if (!this.payId) return [3, 1];
                  tips = this.t('修改已经审核通过的付款账号信息，需要财务重新审核，是否确定修改？');

                  if (this.detailData.pay_account_status === this.$enum.finance.PayAccountStatusEnum.REJECT) {
                    tips = this.t('修改驳回状态的付款账号信息，需要财务重新审核，是否确定修改？');
                  }

                  modal_1 = this.$confirm({
                    title: this.t('提示'),
                    content: tips,
                    onOk: function onOk() {
                      return __awaiter(_this, void 0, Promise, function () {
                        var postData, res, error_1;
                        return __generator(this, function (_a) {
                          switch (_a.label) {
                            case 0:
                              _a.trys.push([0, 2,, 3]);

                              postData = Object.assign(commonParams, {
                                id: id,
                                account_code: account_code,
                                pay_bank_id: pay_bank_id,
                                attachment_url: attachment_url,
                                fiduciary: fiduciary,
                                fiduciary_desc: fiduciary_desc
                              });
                              return [4, this.$api.finance.editPayAccount(postData)];

                            case 1:
                              res = _a.sent();

                              if (res.code === 0) {
                                this.$message.success(this.t('修改成功'));
                                this.visible = false;
                                this.$emit('success');
                              }

                              return [3, 3];

                            case 2:
                              error_1 = _a.sent();
                              modal_1.destroy();
                              return [3, 3];

                            case 3:
                              return [2];
                          }
                        });
                      });
                    }
                  });
                  return [3, 3];

                case 1:
                  postData = Object.assign(commonParams, {
                    account_Infos: account_Infos
                  });

                  if (postData.isthird_party === String(this.$enum.common.BoolIntEnum.NO)) {
                    postData.accept = undefined;
                  }

                  return [4, this.$api.finance.addPayAccount(postData)];

                case 2:
                  res = _a.sent();

                  if (res.code === 0) {
                    data = res.data;
                    errors_1 = [];

                    if (data.every(function (item) {
                      return item.status === 0;
                    })) {
                      this.$message.success(this.t('添加成功'));
                    } else {
                      h_1 = this.$createElement;
                      data.forEach(function (item) {
                        var message = _this.t("\u5145\u503C\u8D26\u6237\u3010{0}\u3011", [item.accountcode]) + item.message;
                        var vnode = h_1('div', {
                          style: {
                            display: 'flex',
                            'align-items': 'center'
                          }
                        }, [h_1('span', item.status === 1 ? {
                          style: {
                            color: '#f5222d',
                            margin: '0 5px',
                            'font-size': '20px'
                          }
                        } : {
                          style: {
                            color: '#52c41a',
                            margin: '0 5px',
                            'font-size': '20px'
                          }
                        }, item.status === 1 ? '×' : '√'), h_1('span', message)]);
                        errors_1.push(vnode);
                      });
                      this.$info({
                        width: 800,
                        title: this.t('提示'),
                        content: h_1('div', errors_1),
                        onOk: function onOk() {}
                      });
                    }

                    this.visible = false;
                    this.$emit('success');
                  }

                  _a.label = 3;

                case 3:
                  return [2];
              }
            });
          });
        });
        return [2];
      });
    });
  };

  PayAccountAddOrEditPage.prototype.validateAgree = function () {
    var _this = this;

    return function (rule, value, callback) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!value) {
            callback(new Error(this.t('请勾选"我已阅读并同意《免责声明》"')));
          } else {
            callback();
          }

          return [2];
        });
      });
    };
  };

  PayAccountAddOrEditPage.prototype.validFormField = function (fieldList) {
    var formDataRef = this.$refs.formDataRef;
    formDataRef === null || formDataRef === void 0 ? void 0 : formDataRef.validateField(fieldList, function () {});
  };

  PayAccountAddOrEditPage.prototype.resetParams = function (formData) {
    var bankItem = this.bankList.find(function (item) {
      return item.bank_code === formData.pay_bank_code;
    });
    var registerCountry = this.registerCountryList.find(function (item) {
      return formData.open_bank_country_code === item.country_code;
    });
    var openBankItem = this.openBankList.find(function (item) {
      return item.bank_branch_name === formData.open_bank_name;
    });
    formData.pay_bank_name = (bankItem === null || bankItem === void 0 ? void 0 : bankItem.bank_name_cn) || '';
    formData.pay_bank_name_en = (bankItem === null || bankItem === void 0 ? void 0 : bankItem.bank_name_en) || '';
    formData.open_bank_country_name = (registerCountry === null || registerCountry === void 0 ? void 0 : registerCountry.country_name) || '';
    formData.payment_lines = (openBankItem === null || openBankItem === void 0 ? void 0 : openBankItem.bank_branch_code) || '';

    if (formData.isthird_party === String(this.$enum.common.BoolIntEnum.YES)) {
      formData.open_bank_country_code = '';
      formData.open_bank_country_name = '';
      formData.open_bank_name = '';
      formData.payment_lines = '';
      formData.swift_code = '';
      formData.bsb_code = '';
    } else if (formData.isthird_party === String(this.$enum.common.BoolIntEnum.NO)) {
      if (formData.open_bank_country_code !== this.$enum.mine.RegisterAreaCodeEnum.CN) {
        formData.payment_lines = '';
      }

      if (!this.isShowSwiftCode) {
        formData.swift_code = '';
      }

      if (!this.payId && formData.open_bank_country_code !== this.$enum.mine.RegisterAreaCodeEnum.AU) {
        formData.bsb_code = '';
      }
    }

    if (!this.isNeedPayeeInfo(formData)) {
      formData.payee_info = null;
    } else if (formData.payee_info && formData.open_bank_country_code !== this.$enum.mine.RegisterAreaCodeEnum.CA) {
      formData.payee_info.street = '';
      formData.payee_info.building_no = '';
      formData.payee_info.postal_code = '';
    }

    if (!this.payId) {
      formData.account_code = '';
      formData.attachment_url = '';
      formData.preview_url = '';
      formData.fiduciary = undefined;
      formData.fiduciary_desc = undefined;
      formData.account_Infos = this.setValidteAccountInfos(formData);
    } else {
      formData.account_Infos = [];

      if (!this.isShowEntrust) {
        formData.attachment_url = '';
        formData.preview_url = '';
        formData.fiduciary = undefined;
        formData.fiduciary_desc = undefined;
      }

      if (formData.fiduciary !== this.$enum.finance.PaymentAccountFiduciaryEnum.OTHER) {
        formData.fiduciary_desc = undefined;
      }
    }
  };

  PayAccountAddOrEditPage.prototype.handlePayAccountNameChange = function () {
    if (!this.payId) {
      var fieldList = this.accountCodeList.map(function (item, index) {
        return "accountCodeIds." + index;
      });
      this.validFormField(fieldList);
    }
  };

  PayAccountAddOrEditPage.prototype.isUnOfficePayByName = function (account) {
    var _a, _b;

    var isNeedUpload = this.formData.pay_account_name && ((_a = this.formData.pay_account_name) === null || _a === void 0 ? void 0 : _a.trim()) !== ((_b = account === null || account === void 0 ? void 0 : account.sign_body_name) === null || _b === void 0 ? void 0 : _b.trim());
    return !!isNeedUpload;
  };

  PayAccountAddOrEditPage.prototype.setValidteAccountInfos = function (formData) {
    var _this = this;

    var accountCodeList = [];
    this.accountCodeList.forEach(function (item) {
      if (formData.accountCodeIds.indexOf(item.account_code) !== -1) {
        var account = _this.$util.findItemByKeyValue(_this.accountCodeList, item.account_code, 'account_code');

        var isUnOfficial = _this.isUnOfficePayByName(account);

        var fiduciary = isUnOfficial ? item.fiduciary : undefined;
        accountCodeList.push({
          account_code: item.account_code,
          attachment_url: isUnOfficial ? item.attachment_url : '',
          fiduciary: fiduciary,
          fiduciary_desc: fiduciary === _this.$enum.finance.PaymentAccountFiduciaryEnum.OTHER ? item.fiduciary_desc : undefined
        });
      }
    });
    return accountCodeList;
  };

  PayAccountAddOrEditPage.prototype.payeeInfoRule = function () {
    return {
      'payee_info.country_code': [{
        required: true,
        message: this.t('请选择付款方国家/地区')
      }],
      'payee_info.province_code': [{
        required: true,
        message: this.t('请选择付款方省/州')
      }],
      'payee_info.city_name': [{
        required: true,
        message: this.t('请输入付款方城市')
      }],
      'payee_info.street': [{
        required: true,
        message: this.t('请输入付款方街道名')
      }],
      'payee_info.building_no': [{
        required: true,
        message: this.t('请输入付款方建筑号')
      }],
      'payee_info.postal_code': [{
        required: true,
        message: this.t('请输入付款方邮编')
      }]
    };
  };

  PayAccountAddOrEditPage.prototype.initPayeeInfo = function (payeeInfo) {
    return {
      country_code: (payeeInfo === null || payeeInfo === void 0 ? void 0 : payeeInfo.country_code) || undefined,
      province_code: (payeeInfo === null || payeeInfo === void 0 ? void 0 : payeeInfo.province_code) || undefined,
      city_name: (payeeInfo === null || payeeInfo === void 0 ? void 0 : payeeInfo.city_name) || '',
      street: (payeeInfo === null || payeeInfo === void 0 ? void 0 : payeeInfo.street) || '',
      building_no: (payeeInfo === null || payeeInfo === void 0 ? void 0 : payeeInfo.building_no) || '',
      postal_code: (payeeInfo === null || payeeInfo === void 0 ? void 0 : payeeInfo.postal_code) || ''
    };
  };

  PayAccountAddOrEditPage.prototype.resetPayeeInfo = function (payeeInfo) {
    if (this.isShowPayeeInfo) {
      this.formData.payee_info = this.initPayeeInfo(payeeInfo);
    } else {
      this.formData.payee_info = null;
    }
  };

  var PayAccountAddOrEditPage_1;
  PayAccountAddOrEditPage.OPEN_BANK_LIST_MAX_COUNT = 100;

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], PayAccountAddOrEditPage.prototype, "bankList", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], PayAccountAddOrEditPage.prototype, "accountList", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], PayAccountAddOrEditPage.prototype, "payId", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": ''
  })], PayAccountAddOrEditPage.prototype, "editDisabled", void 0);

  __decorate([enumData('Finance/IsThirdPartEnum')], PayAccountAddOrEditPage.prototype, "IsThirdPartEnum", void 0);

  __decorate([enumData('Finance/PaymentAccountUnOfficialEnum')], PayAccountAddOrEditPage.prototype, "paymentAccountUnOfficialEnum", void 0);

  __decorate([enumData('Finance/PaymentAccountFiduciaryEnum')], PayAccountAddOrEditPage.prototype, "paymentAccountFiduciaryEnum", void 0);

  __decorate([Common.State('biz_list')], PayAccountAddOrEditPage.prototype, "bizList", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], PayAccountAddOrEditPage.prototype, "onVisibleChange", null);

  __decorate([Watch('formData.pay_bank_code', {
    immediate: true
  })], PayAccountAddOrEditPage.prototype, "onPayBankCodeChange", null);

  __decorate([Watch('formData.open_bank_name', {
    immediate: true
  })], PayAccountAddOrEditPage.prototype, "onOpenBankNameChange", null);

  __decorate([Watch('payId', {
    immediate: true
  })], PayAccountAddOrEditPage.prototype, "onPayIdChange", null);

  __decorate([validateRuleData('/api/v1/finance/pay_account/add')], PayAccountAddOrEditPage.prototype, "getAddRuleData", null);

  __decorate([validateRuleData('/api/v1/finance/pay_account/edit')], PayAccountAddOrEditPage.prototype, "getEditRuleData", null);

  PayAccountAddOrEditPage = PayAccountAddOrEditPage_1 = __decorate([Component({
    components: {
      PaymentAccountDisclaimer: PaymentAccountDisclaimer,
      PayeeInfo: PayeeInfo
    }
  })], PayAccountAddOrEditPage);
  return PayAccountAddOrEditPage;
}(Mixins(MixinsCom));

export default PayAccountAddOrEditPage;